import { createReducer } from '@reduxjs/toolkit'
import { get, keyBy, transform } from 'lodash'

import { selectScid } from 'store/college'
import { isShadow } from 'store/user'

import types from './types'

export { default as actions } from './actions'

const createFeatureMap = (features) => {
  const map = keyBy(features, 'Name')
  return transform(map, (result, feature, key) => {
    result[key] = feature.Enabled
  })
}

export const selectFeatures = (store) => get(store, `features.record`)

export default createReducer(
  {},
  {
    [types.FETCH_FEATURE_TOGGLES_SUCCESS]: (state, action) => {
      state.record = createFeatureMap(action.payload)
    },
  },
)

export const isFeatureEnabled = (store, name) => !!get(store, `features.record.${name}`)

export const selectCanApplicationInsightsSort = (store) => {
  return isFeatureEnabled(store, 'ApplicationInsightsSort')
}

export const selectAppRoundEditDisabled = (store) => {
  return isFeatureEnabled(store, 'DisableAppRoundEdits')
}

export const isGoogleMapsFeatureEnabled = (store) => {
  return isFeatureEnabled(store, 'EnableGoogleMaps')
}

export const isCollegeUpdateRequestEnabled = (store) => {
  return isFeatureEnabled(store, 'AllowCollegeUpdateRequests')
}

export const isDisplayParentYearMetricsEnabled = (store) => {
  return isFeatureEnabled(store, 'displayParentYearMetrics')
}

export const isTnTSearchFilterEnabled = (store) => {
  return isFeatureEnabled(store, 'TnTSearchFilter')
}

export const isHandraisersEnabled = (store) => {
  return isFeatureEnabled(store, 'Handraisers')
}

export const isMedianIncomeSegmentationEnabled = (store) => {
  return isFeatureEnabled(store, 'SupportsMedianIncomeSegmentation')
}

export const isDemoCollegeNameAsScoirEnabled = (store) => {
  const isShadowingBrownU = isShadow(store) && selectScid(store) === 1100217
  return isFeatureEnabled(store, 'DemoCollegeNameAsScoir') && isShadowingBrownU
}
